"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterReading = void 0;
var date_fns_tz_1 = require("date-fns-tz");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var constants_1 = require("../../constants");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var RegisterReading_styled_1 = require("./RegisterReading.styled");
var formatDate = function (date, timeOfUseLabel) {
    return (0, date_fns_tz_1.format)(date, timeOfUseLabel === 'interval' ? constants_1.DATETIME_FORMAT : constants_1.DATE_FORMAT);
};
exports.RegisterReading = (0, react_1.forwardRef)(function (_a, ref) {
    var isNew = _a.isNew, timeOfUseLabel = _a.timeOfUseLabel, date = _a.date, meterReading = _a.meterReading, _b = _a.isEstimated, isEstimated = _b === void 0 ? false : _b, children = _a.children, source = _a.source, rest = __rest(_a, ["isNew", "timeOfUseLabel", "date", "meterReading", "isEstimated", "children", "source"]);
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var Icon = (0, core_1.useComponents)().Icon;
    var newOrLast = isNew ? 'New' : 'Last';
    var label = timeOfUseLabel ? (react_1.default.createElement(Copy, { copyKey: "registerReadingLabelWithTimingCategory", values: {
            timingCategory: (0, utils_1.getFriendlyTimeOfUseLabel)(timeOfUseLabel),
            newOrLast: newOrLast,
        } })) : (react_1.default.createElement(Copy, { copyKey: "registerReadingLabel", values: { newOrLast: newOrLast } }));
    var getSourceCopy = function (source) {
        switch (source) {
            case 'CustomerAgentActual':
                return react_1.default.createElement(Copy, { copyKey: "meterReadingSourceCustomerAgentActual" });
            case 'IndustryActual':
                return react_1.default.createElement(Copy, { copyKey: "meterReadingSourceIndustryActual" });
            case 'IndustryEstimate':
                return react_1.default.createElement(Copy, { copyKey: "meterReadingSourceIndustryEstimate" });
        }
        return null;
    };
    var sourceCopy = getSourceCopy(source);
    return (react_1.default.createElement(RegisterReading_styled_1.RegisterReadingWrapper, __assign({}, rest, { ref: ref }),
        react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingIcon, null,
            react_1.default.createElement(Icon, { name: timeOfUseLabel ? (0, utils_1.getRegisterIcon)(timeOfUseLabel) : 'meter' })),
        react_1.default.createElement(RegisterReading_styled_1.RegisterReadingContent, { "data-testid": "register-reading-content" },
            react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingLabel, null, label),
            react_1.default.createElement("div", null,
                react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingDate, null, date ? (react_1.default.createElement("span", { title: date.toDateString() }, isEstimated ? (react_1.default.createElement(Copy, { copyKey: "registerReadingEstimatedDate", values: { date: formatDate(date) } })) : (formatDate(date)))) : (react_1.default.createElement(Copy, { copyKey: "registerReadingNotAvailable" }))),
                sourceCopy && (react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingSource, null,
                    "\u00A0\u00B7\u00A0",
                    sourceCopy))),
            react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingValue, null, meterReading ? (react_1.default.createElement(Copy, { copyKey: "meterReadingValue", values: {
                    value: meterReading,
                } })) : (react_1.default.createElement(Copy, { copyKey: "meterReadingNotAvailableValue" }))),
            react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingChildren, null, children))));
});
